import { ReactElement } from 'react'
import { NavLink } from 'react-router-dom'
import { I18n } from 'common'
import { navTextStyle } from '../CommonStyles'
import { activeStyle } from '../CommonStyles'
import { navLinkStyle } from '../CommonStyles'

export interface IMenuItem {
  path: string
  text: string
  onClick?: () => void
}

export const MenuItem = (props: IMenuItem): ReactElement => {
  const { path, text, onClick = () => undefined } = props
  return (
    <NavLink
      to={path}
      end
      style={({ isActive }) => ({
        ...navLinkStyle,
        ...(isActive ? activeStyle : {}),
      })}
      onClick={onClick}
    >
      <I18n name={text} style={navTextStyle} />
    </NavLink>
  )
}

export default MenuItem
